module.exports = __webpack_public_path__ + "img/CRASHINO.c55203fb.svg";